import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppSiteGroupsAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeExcludeWebs() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useAutoEuropeDataInfo(d.filterGroupSites ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterGroupSitesExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupSitesExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupSites')

	return (
		<Box>
			<AppAntSwitch
				falseText="Include webs"
				trueText="Exclude webs"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => updateMode(e.target.checked)}
				chipSx={{ mb: 1.5 }}
			/>
			<AppSiteGroupsAutocomplete
				label={isExclusion ? 'Exclude Site Groups' : 'Include Site Groups'}
				placeholder={isExclusion ? 'No site groups excluded' : 'No site groups included'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupSites', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}